<script setup lang="ts">
import VistaTask from '../components/VistaTask.vue';

/**
 * Vista globale di coordinamento: tutti i task del team, con e senza
 * progetto. Il privilegio qui nasconde la rotta; l'autorizzazione vera resta
 * al server, che sull'ambito `team` richiede lo stesso privilegio.
 */
definePage({ meta: { titolo: 'Task del team', privilegi: ['can_read_all_task'] } });
</script>

<template>
  <VistaTask ambito="team" testo-vuoto="Nessun task del team con questi filtri.">
    <template #intestazione>
      <p class="text-xs font-semibold tracking-[0.08em] text-ink-muted uppercase">Coordinamento</p>
      <h1 class="mt-1 font-display text-[33px] leading-[1.07] font-semibold">Task del team</h1>
      <p class="mt-1 hidden text-[13px] text-ink-secondary sm:block">
        Tutte le attività del team, comprese quelle non legate a un progetto.
      </p>
    </template>
  </VistaTask>
</template>
